import AwsAmplify, { Auth } from 'aws-amplify';
import { API } from '@aws-amplify/api';
import awsconfig from '../../../aws-exports';

const AuthUtils = {
  init: () => {
    AwsAmplify.configure(awsconfig);
    Auth.configure(awsconfig);

    API.configure({
      endpoints: [
        {
          name: 'stepsJs',
          endpoint: `https://${process.env.REACT_APP_STAGE}.ark-design-ai.com/js/`,
        },
        {
          name: 'stepsPy',
          endpoint: `https://${process.env.REACT_APP_STAGE}.ark-design-ai.com/py/`,
        },
        {
          name: 'revitApi',
          endpoint: `https://${process.env.REACT_APP_STAGE}.ark-design-ai.com/revitApi/`,
        },
      ],
    });
    AwsAmplify.register(Auth);
    AwsAmplify.register(API);
  },
  isLocalhost: () => window.location.hostname === 'localhost',

  getUser: () => {
    const { user }:any = Auth;
    return user;
  },
};

export default AuthUtils;
